<template>
  <el-dialog
    :title="curItem && curItem.id ? '编辑标签类型' : '添加标签类型'"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :model="formInline"
        ref="form"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="标签类型" prop="tagType">
          <!-- :disabled="!!formInline.id" -->
          <el-input
            v-model="formInline.tagType"
            placeholder="标签类型"
            type="textarea"
            :row="1"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" class="button-info" @click="editFun">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { userTagupdate, userTagaddTag } from "@/api/base.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      picFilesJson: [],
      userList: [],
      deptList: [],
      formInline: {
        tagType: "",
        id: "",
      },
      rules: {
        tagType: [{ required: true, message: "请输入标签类型", trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.curItem && this.curItem.id) {
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
    }
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async editFun(submitFlag) {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        tagType: this.formInline.tagType,
        id: this.formInline.id,
        pid: -1
      };
      const res = await (this.formInline.id ? userTagupdate(params) : userTagaddTag(params));
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList", {
          curItem: this.formInline
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
  },
  computed: {}
};
</script>

<style scoped lang="less">
/deep/ .button-info {
  background: #0054FE !important;
}
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-upload__input {
  display: none;
}
// /deep/.avatar-uploader {
//   display: flex;
// }
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
}
.limitMax {
  /deep/ .el-upload--picture-card {
    background: #fff !important;
    border: none !important;
  }
}
/deep/ .el-textarea__inner {
  padding: 15px !important;
}
/deep/ .el-textarea .el-input__count {
  color: #909399;
  background: transparent;
  position: absolute;
  font-size: 12px;
  bottom: -10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/personLabel/components/typeDialog.vue